var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-top-user"},[_c('div',{staticClass:"icon-wrapper flex-center pointer no-userselect icon-options-wrapper headway-app"},[_c('i',{staticClass:"fa-solid fa-bell"})])])
}]

export { render, staticRenderFns }